import styled from 'styled-components';
import StyledPage from '../styles';
import {sizePx} from '@/theme/helpers/size';
import typography from '@/theme/typography';
import container from '@/theme/constants/container';

export const StyledPlpPage = styled(StyledPage)`
  main {
    max-width: ${container.maxWidth};
    padding: ${container.padding};
    margin: 0 auto;
    flex-shrink: 0;
  }
`;

export const StyledTitle = styled.h1`
  ${typography.Title}
  margin-top: ${sizePx(25)};
  margin-bottom: ${sizePx(5)};
`;

export const StyledSubTitle = styled.p`
  ${typography.Body3}
  margin-bottom: ${sizePx(10)};
`;
